import { Details } from './Details';
import { IMediaProps } from './IMediaProps';
import { useContext, useMemo } from 'react';
import { instanceContext } from '../../../contexts/instance';
import { styled } from '@mui/material/styles';
import classNames from 'classnames';

export const Audio = styled(
	({ children, resource, className, ...props }: IMediaProps) => {
		const { instance: provider } = useContext(instanceContext);

		const { name } = resource;
		const url = useMemo(
			() => provider?.getResourceUrl(resource),
			[resource, provider],
		);
		if (!url) return null;

		return (
			<>
				<div className={classNames('message__audio', className)}>
					<audio controls src={url} title={name} />
				</div>
				<Details {...props} resource={resource}>
					{children}
				</Details>
			</>
		);
	},
	{
		label: 'Audio',
		target: 'Audio-root',
	},
)({
	'& audio': {
		outline: 0,
		width: '100%',
	},
});
